<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <ExportInspDataForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ExportInspDataForm from '@/components/organisms/terminal/form/ExportInspDataForm.vue'

export default {
  name: 'ExportInspDataCSV',

  components: {
    ExportInspDataForm,
  },
}
</script>
